'use client';

import { type FC, useEffect, useRef } from 'react';

type FaderCarouselProps = {
  autoplayspeed?: string;
  containerclass?: string;
  transitionduration?: string;
  children: React.ReactNode | React.ReactNode[];
};

export const FaderCarousel: FC<FaderCarouselProps> = (props) => {
  const { autoplayspeed } = props;
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    let index = 0;
    const total = ref.current?.children.length ?? 0;

    if (total <= 1) {
      const currentSlide = ref.current?.children[index] as HTMLDivElement;
      currentSlide.style.opacity = '1';
      return;
    }

    setInterval(() => {
      if (index === total) index = 0;
      const currentSlide = ref.current?.children[index] as HTMLDivElement;
      const nextSlide = ref.current?.childNodes[
        index + 1 === total ? 0 : index + 1
      ] as HTMLDivElement;

      if (!currentSlide) return;
      if (!nextSlide) return;

      currentSlide.style.opacity = '0';
      nextSlide.style.opacity = '1';

      index++;
    }, Number(autoplayspeed) || 1000);
  }, [autoplayspeed]);

  return (
    <div ref={ref} className={`ui-relative ui-h-full ${props.containerclass}`}>
      {props.children}
    </div>
  );
};

export default FaderCarousel;
